<template>
  <div>
    <div class="manage-company-title row pa-3" style="background-color: #F8F9FA;">
      <v-row>
      <v-col cols="6">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-5 ml-6" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-3">
          เพิ่มบริษัทในเครือ
        </span>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 d-flex align-center justify-end mt-4 action-top-btn">
        <v-btn width="18%" class="button-color-outline ma-0" outlined dark @click="cancelData()">ยกเลิก</v-btn>
        <v-btn width="18%" class="button-color ma-2 mr-5" dark @click="submitData()">บันทึกข้อมูล</v-btn>
      </v-col>
    </v-row>
    </div>
    <div>
      <v-row class="mt-5" justify=center>
      <v-col cols="8">
        <span class="text-sub-color ra-head-text-bold">ชื่อเครือบริษัท</span>
      </v-col>
        <v-col cols="8">
          <v-divider></v-divider>
        </v-col>
    </v-row>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <div class="form-group" v-for="(input,k) in groupCompany" :key="k" style="text-align: center;">
      <v-row class="" justify="center">
        <v-col cols="4" class="form-control text-left">
          <p class="ra-head-text mb-1">ชื่อเครือ (ภาษาไทย)</p>
          <v-text-field
            v-model="groupCompany[k].groupCompanyNameTh"
            outlined
            dense
            :rules="rulesGroupCompanyNameTh"
          ></v-text-field>
        </v-col>
        <v-col cols="4" class="form-control text-left">
          <p class="ra-head-text mb-1">ชื่อเครือ (ภาษาอังกฤษ)</p>
          <v-text-field
            v-model="groupCompany[k].groupCompanyNameEng"
            :rules="rulesGroupCompanyNameEng"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <!-- <v-col cols="2" class="" md="3" sm="3" lg="2" xl="1">
          <v-btn
            rounded
            color="green"
            dark
            icon
            class="btn-add-dep mt-2 mb-3 add_button"
            @click="add(k)"
            v-show="k == groupCompany.length-1"
          >
          <v-icon dark color="white" small>fa-plus</v-icon>
          </v-btn>
          <v-btn
            rounded
            color="green"
            dark
            icon
            class="btn-del-dep mt-2 mb-3 ml-2 add_button"
            @click="remove(k)"
            v-show="k || ( !k && groupCompany.length > 1)"
          >
          <v-icon dark color="white" small>fa-trash-alt</v-icon>
          </v-btn>
        </v-col> -->
        </v-row>
        <v-row class="mt-5" justify=center>
          <v-col cols="8">
            <span class="text-sub-color ra-head-text-bold">บริษัทในเครือ</span>
          </v-col>
            <v-col cols="8">
              <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row v-if="chkDataEmp === 0" class="mt-0" justify=center>
          <v-col cols="8" class="text-center mt-8">
            <img width="150" height="110" src="@/assets/icons/emp-data-icon2.png">
          </v-col>
          <v-col cols="8" class="text-center" style="margin-top: -1%;">
            <span class="" style="font-weight: bold;">ยังไม่มีข้อมูลบริษัทในเครือ</span>
          </v-col>
          <v-col cols="8" class="text-center" style="margin-top: -1%;">
            <span class="ra-head-text">คลิกที่ปุ่มด้านล่างนี้เพื่อเพิ่มบริษัทในเครือของคุณ</span>
          </v-col>
          <v-col cols="8" class="pt-0 pb-0 d-flex align-center justify-center mt-4" style="margin-top: -1%;">
            <v-btn
              outlined
              class="button-color ra-button"
              dark
              @click="addManageCompany()"
            >
            <v-icon left dark color="#fff" size="14px" @click="save">fa-plus</v-icon>
            <span class="ra-text-in-button">
              เพิ่มบริษัท
            </span>
          </v-btn>
          </v-col>
        </v-row>
        <v-row v-else-if="chkDataEmp > 0" class="mt-0" justify=center>
          <!-- <v-col cols="8">
            <TableManageGroup/>
          </v-col> -->
          <v-col cols="8">
            <!-- <v-btn
              color="primary"
              dark
              class="mb-2"
              @click="save"
            >
              เพิ่ม
            </v-btn> -->
            <v-data-table
                :headers="headers"
                :items="desserts"
                sort-by="calories"
                class="elevation-2"
              >
              <template v-slot:[`item.no`]="{ item }">
                {{ desserts.indexOf(item)+1 }}
              </template>
              <template v-slot:[`item._id`]="{ item }">
                  <div>
                    <v-col cols="12">
                      <v-select
                          dense
                          v-model="item._id"
                          :items="itemCompany"
                          label="ชื่อบริษัทในเครือ"
                          item-text="companyFullName"
                          item-value="_id"
                          outlined
                    ></v-select>
                    </v-col>
                  </div>
                </template>
                <template v-slot:top>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                      <v-card height="170px">
                        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
                        <v-card-text class="justify-center text-center">
                        <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span>
                        </v-card-text>
                        <v-card-actions class="">
                          <v-spacer></v-spacer>
                          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogDelete = false">ยกเลิก</v-btn>
                          <v-btn class="ra-button1" color="#1654C6" dark @click="deleteItemConfirm">ลบข้อมูล</v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <!-- <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon> -->
                  <v-btn
                      rounded
                      small
                      dark
                      icon
                      class="ra-border-button mt-3 mb-3 ml-2"
                      @click="deleteItem(item)"
                    >
                    <template v-slot>
                      <img width="17" height="17" src="@/assets/icons/delete-icon.png" >
                    </template>
                    <!-- <v-icon dark color="#464646" small>fa-pen</v-icon> -->
                    </v-btn>
                </template>
                <!-- <template v-slot:no-data>
                  <v-btn
                    color="primary"
                    @click="initialize"
                  >
                    Reset
                  </v-btn>
                </template> -->
                <template v-slot:body.append>
                  <!-- <tr> -->
                  <td></td>
                  <td></td>
                  <td style="margin-left: -6%;" class="pa-2">
                    <v-btn
                      rounded
                      dark
                      icon
                      @click="save"
                    >
                    <v-icon dark class="icon-eye-color" small>fa-plus-circle</v-icon>
                    <span class="icon-eye-color">เพิ่มแถวข้อมูล</span>
                    </v-btn>
                  </td>
                  <!-- <td colspan="4"></td> -->
                  <!-- </tr> -->
                </template>
              </v-data-table>
          </v-col>
        </v-row>
      </div>
    </v-form>
    <div class="text-center">
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
        >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
// import TableManageGroup from './_tableManageGroup'
export default {
  components: {
    // TableManageGroup
  },
  name: 'overview',
  data () {
    return {
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialog: false,
      dialogDelete: false,
      chkDataEmp: 0,
      tokenUser: '',
      nameTh: '',
      nameEng: '',
      valid: true,
      groupCompany: [{
        groupCompanyNameTh: '',
        groupCompanyNameEng: ''
      }],
      tab: null,
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'บริษัท', value: '_id', align: 'start' },
        // { text: 'ชื่อย่อบริษัท', value: '_id', align: 'start' },
        { text: '', value: 'actions', sortable: false }
      ],
      editedIndex: -1,
      itemCompany: [
        'INET',
        'OGS'
      ],
      desserts: [
      ],
      editedItem: {
        _id: ''
      },
      rulesGroupCompanyNameTh: [
        v => !!v || 'กรุณากรอก ชื่อเครือบริษัท'
      ],
      rulesGroupCompanyNameEng: [
        v => !!v || 'กรุณากรอก ชื่อเครือบริษัท'
      ],
      items: [
        'เครือ(กรุ๊ปบริษัท)', 'จัดการบริษัท'
      ]
    }
  },
  mounted () {
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.getGroupCompanyList()
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    desserts (val) {
      // console.log('Dess watch', val.length)
      if (val.length === 0) {
        this.chkDataEmp = 0
      }
    }
    // dialogDelete (val) {
    //   val || this.closeDelete()
    // }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'เพิ่มบริษัทในเครือ' : 'แก้ไขบริษัทในเครือ'
    }
  },
  methods: {
    goBack () {
      // this.$router.push('managecompany')
      this.$router.go(-1)
    },
    addManageCompany () {
      this.chkDataEmp = 1
      this.save()
    },
    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.desserts.splice(this.editedIndex, 1)
      this.dialogDelete = false
      // this.closeDelete()
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    save () {
      if (this.editedIndex > -1 && this.editedIndex === null) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem)
      } else {
        this.desserts.push(this.editedItem)
      }
      this.close()
    },
    cancelData () {
      this.groupCompany[0].groupCompanyNameTh = ''
      this.groupCompany[0].groupCompanyNameEng = ''
      this.desserts = []
      this.$router.push('/managecompany')
      // this.chkDataEmp = 0
    },
    async getGroupCompanyList () {
      const temp = []
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/companys/selectInAddGroup`
      }).then((response) => {
        response.data.result.companyName.map((el, index) => {
          temp.push({
            no: index + 1,
            companyFullName: el.companyShortNameTh + ' - ' + el.companyShortNameEng,
            // companyFullName: el.companyShortNameEng,
            ...el
          })
        })
        this.itemCompany = temp
        // console.log('Company List', this.itemCompany)
      }).catch(e => {
        console.log(e)
      })
    },
    async submitData () {
      // console.log('Dess', this.desserts)
      // console.log('group Company', this.groupCompany)
      // swal('สำเร็จ', 'สร้างเครือบริษัท สำเร็จ', 'success', {
      //   button: false,
      //   timer: 2000
      // })
      // console.log('All Data', this.groupCompany)
      for (let index = 0; index < this.groupCompany.length; index++) {
        if (this.groupCompany[index].groupCompanyNameTh !== '' || this.groupCompany[index].groupCompanyNameEng !== '') {
          // swal('Success', 'สร้างเครือบริษัท สำเร็จ', 'success')
          this.text = 'คุณได้ทำการเพิ่มเครือบริษัทเรียบร้อยแล้ว'
          this.snackbarColor = 'success'
          this.snackbar = true
        } else {
          swal('Warning', 'สร้างเครือบริษัท No', 'warning')
        }
      }
      var filterValue = this.groupCompany.filter(r => {
        if (r.groupCompanyNameTh === '' || r.groupCompanyNameEng === '') {
          this.$refs.form.validate()
          return r
        }
      })
      if (filterValue.length !== 0) {
        swal('คำเตือน', 'กรุณากรอกข้อมูลให้ครบ', 'warning')
      } else {
        await this.axios({
          method: 'post',
          url: `${this.api}/api/vMonk/groupCompany`,
          headers: {
            authorization: this.tokenUser
          },
          data: {
            // groupCompany: this.groupCompany
            groupCompanyNameTh: this.groupCompany[0].groupCompanyNameEng,
            groupCompanyNameEng: this.groupCompany[0].groupCompanyNameTh,
            listCompany: this.desserts
          }
        }).then((response) => {
          // console.log('Get Edit', response.data.result)
          swal('สำเร็จ', 'สร้างเครือบริษัท สำเร็จ', 'success', {
            button: false,
            timer: 2000
          })
          this.groupCompanyNameTh = ''
          this.groupCompanyNameEng = ''
          // location.reload()
          this.$router.push('/managecompany')
        }).catch(e => {
          console.log(e)
          swal('ผิดพลาด', 'ชื่อเครือบริษัท ซ้ำ!', 'error')
        })
      }
    },
    add () {
      // this.nameTh = ''
      // this.nameEng = ''
      this.groupCompany.push({
        groupCompanyNameTh: '',
        groupCompanyNameEng: ''
      })
      // console.log('Push Company', this.groupCompany)
    },
    remove (index) {
      this.groupCompany.splice(index, 1)
    }
  }
}
</script>
<style scoped>
@import '../../../css/Create.css';
@import '../../../css/Re-Desing/Gobal-Design.css';
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.ra-border-button {
  background: #FFFFFF;
  /* Color / Neutral / #EEEEEE */
  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;

  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
}
</style>
